import { DonationBatchPage } from './DonationBatchPage';

export function DonationPublishPage() {
  return <DonationBatchPage panel="publish" title="Market Promotion Publish Panel" />;
}
